import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '../../assets/time.png';
import _imports_1 from '../../assets/phone.png';
import _imports_2 from '../../assets/location.png';
var _hoisted_1 = { class: "info-detail" };
var _hoisted_2 = { class: "main-picture" };
var _hoisted_3 = ["src"];
var _hoisted_4 = { class: "info" };
var _hoisted_5 = { class: "info-item" };
var _hoisted_6 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1);
var _hoisted_7 = { class: "content" };
var _hoisted_8 = { class: "info-item" };
var _hoisted_9 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: ""
}, null, -1);
var _hoisted_10 = { class: "content" };
var _hoisted_11 = { class: "info-item" };
var _hoisted_12 = /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_2,
    alt: ""
}, null, -1);
var _hoisted_13 = { class: "content" };
var _hoisted_14 = /*#__PURE__*/ _createElementVNode("button", null, [
    /*#__PURE__*/ _createElementVNode("span", null, "地圖")
], -1);
var _hoisted_15 = { class: "detail-content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.info)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("section", _hoisted_2, [
                    _createElementVNode("img", {
                        src: "" + _ctx.info.picture,
                        alt: "景點美食圖"
                    }, null, 8, _hoisted_3)
                ]),
                _createElementVNode("section", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.info.openTime), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.info.phone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _hoisted_12,
                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.info.address), 1),
                        _hoisted_14
                    ])
                ]),
                _createElementVNode("section", _hoisted_15, _toDisplayString(_ctx.info.description), 1)
            ], 64))
            : _createCommentVNode("", true)
    ]));
}
